import { useEffect, useState } from 'react'

import { getRefrigerantTypeApi } from '../jobs.api'
import { allowedRefTypes } from '../jobs.description'

const refrigerantType = () => {
  const [refrigerantList, setRefrigerantList] = useState({})
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    getRefTypeList()
  }, [])

  const getRefTypeList = async () => {
    setLoader(true)
    const response = await getRefrigerantTypeApi()
    setLoader(false)
    let data = {}
    response?.data?.map &&
      allowedRefTypes.forEach(ref => {
        data = { ...data, [ref]: response?.data?.map[ref] }
      })
    if (response?.data) {
      setRefrigerantList(data)
    }
  }

  return { refrigerantList, loader }
}

export default refrigerantType
